<template>
  <v-text-field
    ref="text"
    type="number"
    :value="value"
    @input="update"
    :label="name"
    :error-messages="errorMessages"
  />
</template>

<script>

export default {
  name: 'NumberMetadata',
  props: {
    name: {
      type: String,
      mandatory: true,
    },
    value: {
    },
    digitNumber: {
      type: Number,
      mandatory: true,
    },
    mandatory: {
      type: Boolean,
      mandatory: true,
    },
  },
  components: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    errorMessages() {
      if (!this.mandatory) {
        return null;
      }

      return !this.value ? 'Pflichfeld' : null;
    }
  },
  methods: {
    update(newValue) {
      if (newValue && this.digitNumber > 0 && !isNaN(parseInt(newValue))) {
        const digitNumber = newValue
          .replace('.', '')
          .replace('-', '')
          .replace('+', '')
          .length;

          if (digitNumber > this.digitNumber) {
            this.$refs.text.lazyValue = this.value; // HACK for buggy v-text-input
            this.$emit('input', this.value);
            return;
          }
      }
      this.$emit('input', newValue);
    },
  },
  data() {
    return {
    };
  },
};
</script>
